import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import OfferCalendarRoomOptions from './OfferCalendarRoomOptions'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

function OfferCalendarRoomModal() {
  const { resolve } = useModalElementContext()
  const intl = useIntl()

  const onRoomSelect = useCallback(() => {
    resolve?.()
  }, [resolve])

  return (
    <Modal
      title={intl.formatMessage({
        id: 'yB5a7BzgCQ',
        defaultMessage: 'Rooms',
        description: 'Title for rooms selection modal in offer calendar',
      })}
      primaryActionText={intl.formatMessage({
        id: 'qr/dyO1wCZ',
        defaultMessage: 'Apply',
        description: 'Button text to apply room selection in offer calendar modal',
      })}
    >
      <OfferCalendarRoomOptions onSelect={onRoomSelect} />
    </Modal>
  )
}

export default OfferCalendarRoomModal
